import { createAsyncThunk } from "@reduxjs/toolkit";
import { AXIOS_RESERVATION } from "../../../../utils/axiosInterceptors";
import { config } from "../../../../config";

export const fetchRooms = createAsyncThunk(
  "rooms/getallroom",
  async (state, { getState, rejectWithValue, dispatch }) => {
    // console.log("amenities payload:", state);

    try {
      let { data } = await AXIOS_RESERVATION.get(`getallroom`);
      // console.log("data:", data);

      return data;
    } catch (err) {
      // console.log("err:", err);

      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);

export const addNewRoom = createAsyncThunk(
  "rooms/addnewroom",
  async (state, { getState, rejectWithValue, dispatch }) => {
    // console.log("rooms payload:", state);

    let { CB, ...others } = state;
    others.hotelId = config.HOTELID;

    console.log("others:", others);

    var headers = {
      "Access-Control-Allow-Origin": "*",
    };

    try {
      let { data } = await AXIOS_RESERVATION.post(`addnewroom`, others, {
        headers,
      });
      // console.log("data:", data);

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(fetchRooms());

        return data;
      }
    } catch (err) {
      // console.log("err:", err);

      CB && CB(err);
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);

export const editRoom = createAsyncThunk(
  "rooms/editRoom",
  async (state, { getState, rejectWithValue, dispatch }) => {
    // console.log("rooms payload:", state);

    let { CB, ...others } = state;
    // console.log("others:", others);
    // console.log("CB:", CB);

    try {
      let { data } = await AXIOS_RESERVATION.post(`editRoom`, others);

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(fetchRooms());

        return data;
      }
    } catch (err) {
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong Please try again later",
        },
      });
    }
  }
);

export const removeRoom = createAsyncThunk(
  "rooms/removeRoom",
  async (state, { getState, rejectWithValue, dispatch }) => {
    // console.log("rooms payload:", state);

    let { id, CB } = state;
    // console.log("id:", id);

    var headers = {
      _id: id,
      "Access-Control-Allow-Origin": "*",
    };
    try {
      let { data } = await AXIOS_RESERVATION.delete(`removeRoom`, {
        headers,
      });

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(fetchRooms());

        return data;
      }
    } catch (err) {
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong Please try again later",
        },
      });
    }
  }
);
